/* eslint-disable react/no-array-index-key */
import React from 'react';

import { Box, Skeleton, Stack } from '@mui/material';

import { COLOR } from '../../../helpers/colors';

const textBox = (
  <Skeleton
    animation="wave"
    variant="text"
    color={COLOR.PH}
    style={{
      width: '25%',
    }}
  />
);
const imagePlaceholder = (height, width) => (
  <Skeleton
    animation="wave"
    variant="rectangular"
    color={COLOR.PH}
    style={{
      width,
      height,
    }}
  />
);
const BillingPlaceholder = () => (
  <Box
    sx={{
      marginY: 6,
      border: `1px solid ${COLOR.borderColor}`,
      borderRadius: 1,
    }}
  >
    <Stack direction="row" justifyContent="space-between" sx={{ m: 2 }}>
      {imagePlaceholder(20, 20)}
      {imagePlaceholder(20, 20)}
    </Stack>
    <Stack
      direction="row"
      justifyContent="space-between"
      spacing={8}
      sx={{ borderBottom: `1px solid ${COLOR.borderColor}`, p: 2 }}
    >
      {textBox}
      {textBox}
      {textBox}
      {textBox}
      {textBox}
      {textBox}
      {textBox}
    </Stack>
    {[0, 1, 2, 3].map((d, index) => (
      <Stack
        key={index.toString()}
        direction="row"
        justifyContent="space-between"
        spacing={8}
        sx={{ p: 2 }}
      >
        {textBox}
        {textBox}
        {textBox}
        {textBox}
        {textBox}
        {textBox}
        {textBox}
      </Stack>
    ))}
  </Box>
);

export default BillingPlaceholder;
